// Ademero privacy-choice rule: no third-party tracking (gtag / GA4 / Google
// Ads) and no marketing attribution storage until the visitor clicks Accept.
// Decline (or no choice yet) loads nothing.
export const PRIVACY_CHOICE_STORAGE_KEY = 'ademero_privacy_choice_v1';
export const PRIVACY_CHOICE_CHANGED_EVENT = 'ademero-privacy-choice-changed';
export const PRIVACY_CHOICE_RESET_EVENT = 'ademero-privacy-choice-reset';

const GA_MEASUREMENT_ID = 'G-RZ3419FE8K';
const GOOGLE_ADS_ID = 'AW-16550211969';

export const getPrivacyChoice = () => {
  try {
    const value = window.localStorage.getItem(PRIVACY_CHOICE_STORAGE_KEY);
    return value === 'granted' || value === 'denied' ? value : null;
  } catch (err) {
    return null;
  }
};

export const hasMarketingConsent = () => getPrivacyChoice() === 'granted';

export const setPrivacyChoice = choice => {
  try {
    window.localStorage.setItem(PRIVACY_CHOICE_STORAGE_KEY, choice);
  } catch (err) {
    // Storage blocked: the choice still applies to this page view.
  }
  window.dispatchEvent(new CustomEvent(PRIVACY_CHOICE_CHANGED_EVENT, { detail: { choice } }));
  if (choice === 'granted') {
    loadMarketingTags();
  }
};

// "Cookie choices": forget the choice and show the banner again.
export const resetPrivacyChoice = () => {
  try {
    window.localStorage.removeItem(PRIVACY_CHOICE_STORAGE_KEY);
  } catch (err) {
    // Ignore storage failures.
  }
  window.dispatchEvent(new CustomEvent(PRIVACY_CHOICE_RESET_EVENT));
};

// Loads gtag.js (GA4 + Google Ads) once, only after consent and only in the
// production build.
export const loadMarketingTags = () => {
  if (
    process.env.REACT_APP_DEPLOYMENT_TYPE !== 'production' ||
    !hasMarketingConsent() ||
    document.getElementById('ga1')
  ) {
    return;
  }

  const script1 = document.createElement('script');
  script1.id = 'ga1';
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script1);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID);
  window.gtag('config', GOOGLE_ADS_ID);
};
